module.exports = __webpack_public_path__ + "static/media/logo.edb26c92.png";